import { render, staticRenderFns } from "./QuestionSaved.vue?vue&type=template&id=0c43f460&scoped=true&"
import script from "./QuestionSaved.vue?vue&type=script&lang=js&"
export * from "./QuestionSaved.vue?vue&type=script&lang=js&"
import style0 from "./QuestionSaved.vue?vue&type=style&index=0&id=0c43f460&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c43f460",
  null
  
)

export default component.exports